import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from "@angular/core";
import { SaleMethodBranchModel, SaleMethodNature } from "src/app/frontoffice/sales/model/sale-method-branch.model";
import { SalonOrderService } from "../salonorder.service";
import { NotificationService } from "projects/sepidz-web-framework/src/lib/services/notification.service";
import { delay, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { ActivePageEnum } from "../../model/activepage.enum";

@Component({
  selector: "order-salon",
  templateUrl: "./salonorder.component.html",
  styleUrls: ["./salonorder.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SalonOrderComponent implements OnInit, OnDestroy {
  @Input() SaleMethodBranchId: number;
  @Input() currentSaleMethodBranch: SaleMethodBranchModel;
  private ngUnsubscribe = new Subject();
  constructor(private cd: ChangeDetectorRef, public salonOrder: SalonOrderService, private notification: NotificationService) {}

  ngOnInit(): void {
    this.fillData();
    this.init();
    this.salonOrder._changeTable = this.salonOrder.order.common.LocalSetting.OrderSetting.salonTableSize;
  }

  private init(): void {
    this.notification.init();
    this.notification.notification$.pipe(takeUntil(this.ngUnsubscribe), delay(1000)).subscribe((value) => {
      if (
        value.Key === "InvoiceChanges" &&
        value.Message === SaleMethodNature.Restaurant &&
        this.salonOrder.order.currentActivePage == ActivePageEnum.Salon
      ) {
        this.salonOrder.getTablesRead(this.salonOrder.selectedSalons);
        this.cd.markForCheck();
        this.cd.detectChanges();
      }
    });
  }

  fillData() {
    this.salonOrder.order.cd_Salons = this.cd;
    this.salonOrder.getSalon();
  }

  updateActivityPageStatus() {
    this.salonOrder.order.shouldActivateSalonPage = true;
    this.salonOrder.order.shouldActivateInvoicesPage = false;
  }
  ngOnDestroy(): void {
    if (this.ngUnsubscribe) {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
    }
  }

  protected refreshTables() {
    this.salonOrder.order.splashFormService.openDialog("", " ");
    this.salonOrder.getTablesRead(this.salonOrder.selectedSalons);
  }

  changeTableSize() {
    this.salonOrder._changeTable = !this.salonOrder._changeTable;
    this.salonOrder.order.common.LocalSetting.OrderSetting.salonTableSize = this.salonOrder._changeTable;
    this.salonOrder.order.common.updateSettings();
  }
}
